// Material UI
import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  dialogPaper: {
    width: '488px',
  },
  root: {},
  timeSelectorsContainer: {
    display: 'flex',
    marginBottom: '24px',
    marginTop: '20px',
  },
  unitOfTimeSelect: {
    marginLeft: '10px',
  },
}));
